<!--
Popover — wrapper do Popover do PrimeVue, para painéis flutuantes ancorados
num elemento (o painel de notificações da barra de topo é o primeiro uso).

Existe pelo mesmo motivo dos outros wrappers de `src/ui/`: uma troca de
biblioteca acontece AQUI, e não espalhada pelos domínios. A regra
`no-raw-inputs` é o que garante isso, e foi ela que pediu este arquivo.

`toggle`/`hide` são REEXPOSTOS de propósito: quem usa um popover chama esses
dois métodos pela ref, e sem o `defineExpose` a ref apontaria para o wrapper
— que não teria método nenhum, e o painel simplesmente não abriria.
-->

<template>
  <PrimePopover ref="interno" v-bind="$attrs">
    <slot />
  </PrimePopover>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PrimePopover from 'primevue/popover';

defineOptions({ name: 'Popover', inheritAttrs: false });

const interno = ref<{ toggle: (e: Event) => void; hide: () => void } | null>(null);

defineExpose({
  toggle: (e: Event): void => interno.value?.toggle(e),
  hide: (): void => interno.value?.hide(),
});
</script>
